import { mapValuesKey } from 'zustand-x';
import { authStore } from '@core/store/auth';
import { configStore } from '@core/store/config';
import { fullscreenStore } from '@core/store/fullscreen';
import { modalStore } from '@core/store/modal';
import { sidebarStore } from '@core/store/sidebar';
import { themeStore } from '@core/store/theme';
import { languageStore } from '@core/store/language';
import { bottomMenuStore } from './bottomMenu';
import { applicationStore } from './application';
import { goBackStore } from './goBack';
import { useFiltersStore } from './activealertFilter';
import { useNotificationStore } from './pushNotification';
import { useRemovePaddingStore } from './removePadding';

export const rootStore = {
  theme: themeStore,
  modal: modalStore,
  sidebar: sidebarStore,
  auth: authStore,
  config: configStore,
  fullscreen: fullscreenStore,
  language: languageStore,
  bottomMenu: bottomMenuStore,
  application: applicationStore,
  goBack: goBackStore,
  alertsfilter: useFiltersStore,
  pushNotification: useNotificationStore,
  removePadding: useRemovePaddingStore,
};

export const useStore = () => mapValuesKey('use', rootStore);
export const store = mapValuesKey('get', rootStore);
export const actions = mapValuesKey('set', rootStore);
